module.exports = __webpack_public_path__ + "static/media/icons-close.5743ef4f.svg";